import {
  Col,
  Form,
  Row,
  UploadProps,
  Space,
  Upload,
  Image,
  Checkbox,
} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation } from 'react-router-dom';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useMutation } from 'react-query';
import CreateCartPage from '../../../../pages/Cart/PreOrder/CreatePreOrder';
import { ColumnsType } from 'antd/es/table';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { Table } from 'antd/lib';
import * as XLSX from 'xlsx';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { openNotificationWithIcon } from 'utils/notification';
import { IProduct } from 'interface/product.interface';
import CartApi from 'apis/CartApi';
import formatDate from 'utils/formatDate';
import { STATUS } from 'constants/reponseStatus';
import pageTitleStore from 'store/pageTitleStore';

export default function CreateCartInfo(): JSX.Element {
  const history = useHistory();
  const queryParam = useQueryParam();
  const location = useLocation<{
    cart: any;
  }>();

  const setStep = useCategoryManagementStore((state) => state.setStep);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const [products, setProductData] = useState<IProduct[]>([]);
  const [listProductSelected, setListProductSelected] = useState<IProduct[]>(
    []
  );
  const [total, setProductTotalData] = useState<number>(0);
  const [checkAll, setCheckAll] = useState(false);
  const [page, setPage] = useState(parseInt(queryParam.get('page') + '') || 1);
  const [page_size, setPage_size] = useState(
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE
  );

  const cart = location.state?.cart;

  const params = {
    cart_code: cart?.cart_code || '',
    page: page,
    page_size: page_size,
  };

  const { mutate: getProducts, isLoading: isProductLoading } = useMutation(
    ['getProductByPofCode', page],
    () => CartApi.getProductOfCartChiNhanh(params),
    {
      onSuccess: (response: any) => {
        setProductData(response.data);
        setProductTotalData(response.total || 0);
      },
      onError: (error: any) => {
        setProductData([]);
        setProductTotalData(0);
      },
    }
  );

  const { mutate: getAllProducts, isLoading: isSetAllProductLoading } =
    useMutation(
      ['getProductByPofCode', page],
      () =>
        CartApi.getProductOfCartChiNhanh({
          cart_code: cart?.cart_code || '',
          page: page,
          page_size: total,
        }),

      {
        onSuccess: (response: any) => {
          if (response.status === STATUS.SUCCESS) {
            const updatedData = response.data.map((item: any) => ({
              ...item,
              // chi_nhanh: '1005, 1006',
              // cua_hang: '1101',
            }));
            setProductData(updatedData || []);
            setListProductSelected(updatedData);
            generateExcel(updatedData);
          }
        },
        onError: (error: any) => {
          console.log(error);
        },
      }
    );

  const columns: ColumnsType<IProduct> = [
    {
      title: (
        <Checkbox
          checked={checkAll}
          onChange={(e) => {
            if (e.target.checked) {
              getAllProducts();
            } else {
              setListProductSelected([]);
            }
            setCheckAll(e.target.checked);
          }}
        />
      ),
      dataIndex: 'isSelected',
      width: 80,
      align: 'center',
      render: (text, record) => (
        <Checkbox
          checked={listProductSelected
            .map((item) => item.ma_mau)
            .includes(record.ma_mau)}
          onChange={(e) => handleCheckboxChange(record, e.target.checked)}
        />
      ),
    },
    {
      title: 'STT',
      dataIndex: 'ma_mau',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      width: 177,
    },

    {
      title: 'Tên mẫu',
      dataIndex: 'ten_mau',
      width: 261,
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (record: any) => {
        return (
          <Image
            className="border border-solid border-neutral-90 rounded-lg"
            src={record}
            width={50}
            height={50}
          />
        );
      },
      width: 100,
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'nhan_hang',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'nganh_hang',
    },
    {
      title: 'Dòng hàng Xman',
      dataIndex: 'dong_hang',
      width: 148,
    },
    // {
    //   title: 'X-man',
    //   dataIndex: 'xman',
    //   width: 148,
    // },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 148,
    },
    {
      title: 'Kết luận đánh giá 3 tiêu chí',
      dataIndex: 'kldg_3tc',
      width: 148,
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      dataIndex: 'doanhthu_6th',
      width: 148,
      align: 'right',
    },
    {
      title: 'Tổng SL tồn hiện tại',
      dataIndex: 'tongsl_ton',
      width: 112,
      align: 'right',
    },
    {
      title: 'Tổng giá trị tồn hiện tại',
      dataIndex: 'tong_giatri',
      width: 112,
      align: 'right',
    },
    {
      title: 'Giá trung bình',
      dataIndex: 'gia_tb',
      width: 112,
      align: 'right',
    },
    {
      title: 'Cửa hàng',
      dataIndex: 'cua_hang',
      width: 112,
    },
    {
      title: 'Số lượng phân bổ',
      dataIndex: 'so_luong_phan_bo',
      width: 112,
    },
    {
      title: 'Vốn tồn phân bổ',
      dataIndex: 'von_ton_phan_bo',
      width: 112,
    },
    // {
    //   title: 'Product code',
    //   dataIndex: 'pro_code',
    //   width: 112,
    // },
    // {
    //   title: 'Pof code',
    //   dataIndex: 'pof_code',
    //   width: 112,
    // },
    {
      fixed: 'right',
      align: 'center',
      width: 0,
    },
  ];

  useEffect(() => {
    setStep(0);
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
    setTitle('Khai báo đăng kí mẫu');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/preorder">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/preorder">Đăng ký mẫu</a>
          </p>
        ),
      },
      { title: <a href="">Khai báo đang kí mẫu</a> },
    ]);

    getProducts();
  }, [page, page_size]);

  const onNextStep = () => {
    if (listProductSelected.length != 0) {
      history.push(`/preorder-create-review`, {
        cart: cart,
        listProductSelected: listProductSelected,
      });
    } else {
      openNotificationWithIcon(
        'error',
        'Chưa có mẫu sản phẩm nào được chọn, vui lòng chọn mẫu sản phẩm'
      );
    }
  };

  function handleCheckboxChange(record: IProduct, checked: boolean) {
    if (checked) {
      if (!listProductSelected.some((item) => item.ma_mau === record.ma_mau)) {
        setListProductSelected([...listProductSelected, record]);
      }
    } else {
      const updatedList = listProductSelected.filter(
        (item) => item.ma_mau !== record.ma_mau
      );
      setListProductSelected(updatedList);
    }
  }

  function generateExcel(listProductSelected: any) {
    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      if (column.dataIndex === 'isSelected') {
        return 'Đã chọn';
      } else {
        return column.title;
      }
    });
    data.push(headerRow);

    // create data
    listProductSelected.forEach((product) => {
      const rowData = columns.map((column) => {
        if (column.dataIndex === 'isSelected') {
          return true;
        }
        return product[column.dataIndex];
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `mau_san_pham.xlsx`);
  }

  function handleUploadFile(info: UploadProps) {
    try {
      if (info.fileList) {
        const files = info.fileList.map((file: any) => {
          return file.originFileObj;
        });
        if (files.length != 0) {
          const file = info.fileList[0];
          // setSelectedFile(file);
          const reader = new FileReader();

          reader.onload = (e) => {
            if (e.target) {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              let excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
                header: 1,
                range: 0,
              });
              if (excelData.length == 0 || excelData[0][0] != 'Đã chọn') {
                openNotificationWithIcon(
                  'error',
                  'File không đúng mẫu, vui lòng tải mẫu'
                );
                return;
              }
              excelData = excelData.slice(1);

              const products: IProduct[] = [];
              excelData.forEach((row) => {
                const product: any = {};

                for (let index = 0; index < row.length; index++) {
                  const value = row[index];
                  product[columns[index].dataIndex] =
                    columns[index].dataIndex == 'cua_hang'
                      ? value
                        ? value.toString()
                        : null
                      : value;
                }
                products.push(product);
              });
              openNotificationWithIcon('success', 'File đã được tải lên');
              setListProductSelected(products);
            }
          };
          const blob = file.originFileObj as Blob;
          reader.readAsArrayBuffer(blob);
        }
      }
    } catch (err) {
      openNotificationWithIcon('error', 'File không đúng định dạng mẫu');
    }
  }

  const productsData = [...products];

  listProductSelected.forEach((selectedItem) => {
    const index = productsData.findIndex(
      (productItem) => productItem.ma_mau === selectedItem.ma_mau
    );
    if (index !== -1) {
      productsData[index] = selectedItem;
    }
  });

  return (
    <CreateCartPage isLoading={isProductLoading}>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        <Content>
          <div className="text-xl font-bold mb-6">1. Thông tin giỏ hàng</div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Tên giỏ hàng
                </Col>
                <Col className="" span={12}>
                  : <strong>{cart?.cart_name}</strong>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Loại giỏ hàng
                </Col>
                <Col className="" span={12}>
                  : {cart?.cart_type_name}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Thời gian hiện hành
                </Col>
                <Col className="" span={12}>
                  : {formatDate(cart?.release_date)}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={3}>
              Mô tả
            </Col>
            <Col className="" span={20}>
              : {cart?.description}
            </Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Người tạo
                </Col>
                <Col className="" span={12}>
                  : {cart?.created_by}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Email
                </Col>
                <Col className="" span={12}>
                  : {cart?.email}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Khối phát hành
                </Col>
                <Col className="" span={12}>
                  : {cart?.division}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Công ty phát hành
                </Col>
                <Col className="" span={12}>
                  : {cart?.company}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={3}>
              Đơn vị phát hành
            </Col>
            <Col className="" span={20}>
              : {cart?.department_name}
            </Col>
          </Row>
        </Content>

        <Content>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle"
            className="mb-3"
          >
            <Col span={12}>
              <div className="text-xl font-bold">Mã mẫu</div>
            </Col>
            <Col span={12}>
              <Row justify="end" align="middle">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                    onClick={() => {
                      if (listProductSelected.length == 0) {
                        getAllProducts();
                      } else {
                        generateExcel(listProductSelected);
                      }
                    }}
                  >
                    <DownloadOutlined />
                    Tải file excel
                  </Button>
                </Space>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <Space>
                  <Upload
                    accept=".xlsx,.xls,.csv"
                    onChange={handleUploadFile}
                    beforeUpload={() => false}
                    fileList={[]}
                    showUploadList={false}
                  >
                    <Button
                      bgColor={'bg-white'}
                      color={'text-primary-50'}
                      border={'border-primary-50'}
                      customClass="fix-border-radius"
                    >
                      <UploadOutlined />
                      Upload file
                    </Button>
                  </Upload>
                </Space>
              </Row>
            </Col>
          </Row>
          <Table
            rowKey={(record) => record.ma_mau}
            columns={columns}
            scroll={{ x: 958 }}
            className="customTable"
            dataSource={productsData}
            loading={isProductLoading}
            pagination={{
              className: 'flex items-center',
              current: page,
              pageSize: page_size,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              // onChange: HocChangePagination(history),
              onChange: (page: number, pageSize: number) => {
                setPage(page);
                setPage_size(pageSize);

                history.push('/preorder-create-order', {
                  cart: cart,
                  page: page,
                  page_size: pageSize,
                });
              },
            }}
          />
        </Content>
        <Row
          className="mt-8"
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
        >
          <Col className="flex justify-end gap-2.5" span={8}>
            <Form.Item className="mr-2">
              <Button
                onClick={() => (window.location.href = '/category')}
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
              >
                Trở lại
              </Button>
            </Form.Item>
            <Form.Item>
              <Button onClick={onNextStep}>Tiếp theo</Button>
            </Form.Item>
          </Col>
        </Row>
        {/* </Form> */}
      </div>
    </CreateCartPage>
  );
}
